<template>
  <div class="background">
    <div class="verification-container">
      <div class="circle">
        <div class="triangle-block">
          <div class="triangle"></div>
        </div>
      </div>
      <h2 v-if="!errorMessage">Thanks for verifying your email.</h2>
      <h2 v-if="errorMessage">{{ errorMessage }}</h2>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      errorMessage: "",
    };
  },
  async mounted() {
    const { token } = this.$route.query;

    if (token) {
      try {
        const baseURI = `https://api.rentapplication.net/api/v2/email/verify/`;
        await axios.post(baseURI, { token });
      } catch (err) {
        this.errorMessage = "Invalid token. Email is not verified properly.";
      }
    } else {
      this.errorMessage = "Invalid token. Email is not verified properly.";
    }
  },
};
</script>
<style lang="scss" scoped>
h2 {
  color: #545454;
  font-size: 20px;
  line-height: 1;
  font-weight: normal;
  text-align: center;
  margin-top: 0;
}
.circle {
  width: 87px;
  height: 87px;
  background: #94c959;
  border-radius: 50%;
  margin: 150px auto 70px;
  .triangle-block {
    height: 87px;
    display: table-cell;
    vertical-align: middle;
    .triangle {
      width: 44px;
      height: 23px;
      border: 7px solid #fff;
      box-sizing: border-box;
      border-top: none;
      border-right: none;
      margin-left: 22px;
      margin-top: -3px;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
}
</style>
